// src/Clock.js
import React, { useState, useEffect } from 'react';
import { formatDate } from './formatDate';

export default function Clock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const time = now.toLocaleTimeString([], { hour12: false });
  const date = formatDate(now, { shortYear: true });

  return (
    <div style={clockStyle.container}>
      <span style={clockStyle.text}>{time}</span>
      <br />
      <span style={clockStyle.date}>{date}</span>
    </div>
  );
}

const clockStyle = {
  container: {
    textAlign: 'right',
    fontFamily: "'Reddit Mono', monospace",
    fontSize: '12px',
    color: '#000',
    lineHeight: 1.4,
  },
  text: {
    fontSize: '12px',
  },
  date: {
    fontSize: '12px',
  },
};
